<script setup>
import { useTextStore } from '@/stores/texts'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const store = useTextStore()
const route = useRoute()

const isBright = computed(() => {
  return route && route.name === 'result'
})
</script>
<template>
  <img
    v-if="store.language == 'de-ch'"
    :src="isBright ? '/logos/logo_de_bright.svg' : '/logos/logo_de.svg'"
    alt="Lohnrechner"
    width="113"
    height="38"
  />
  <img
    v-if="store.language == 'fr-ch'"
    :src="isBright ? '/logos/logo_fr_bright.svg' : '/logos/logo_fr.svg'"
    alt="Calculateur de salaire"
    width="150"
    height="38"
  />
  <img
    v-if="store.language == 'it-ch'"
    :src="isBright ? '/logos/logo_it_bright.svg' : '/logos/logo_it.svg'"
    alt="Calcolatore salariale"
    width="150"
    height="38"
  />
</template>

<style scoped>
img {
  height: 38px;
  width: auto;
}
</style>
